export enum ProbabilityCategories {
  Fail = "Certain to fail",
  Low = "Low",
  Uncertain = "Uncertain",
  Likely = "Likely to succeed",
  VeryLikely = "Very likely to succeed",
  Certain = "Certain to succeed"
};


// WEBPACK FOOTER //
// ./src/models/Probabilities.ts